import React from 'react'
import { Field, FieldArray, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import LoadingProgress from '../components/LoadingProgress'
import { bindActionCreators } from 'redux'
import ColorPickerField from '../utils/ColorPickerField'
import { renderInputField, renderSelectField } from '../utils/forms'
import '../styles/FormModals.css'
import '../styles/ArticlesView.css'

import { fetchArticles, updateArticle } from '../actions/articles'

class ArticlesView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      editSeason: false,
      editWhitelist: false,
      editClickAndCollect: false,
      editERP: false
    }

    this.handleSaveSection = this.handleSaveSection.bind(this)
    this.handleCancelEdit = this.handleCancelEdit.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.renderSeason = this.renderSeason.bind(this)
    this.renderOperators = this.renderOperators.bind(this)
    this.renderClick = this.renderClick.bind(this)
    this.renderERP = this.renderERP.bind(this)
  }


  componentDidMount() {

    this.props.fetchArticles();

  }

  onSubmit(formValues) {

    const updatedFormValues = {
      ...formValues,
      ClickAndCollect: (formValues.ClickAndCollect || []).map(locker => ({
        ...locker,
        type: locker.type || 'BN3XL',
        zone: locker.zone || '1',
        price: locker.price || ''
      })),
      Season: (formValues.Season || []).map(locker => ({
        ...locker,
        type: locker.type || 'BN3XL',
        zone: locker.zone || '1',
        price: locker.price || ''
      })),
      ERP: {
        ...formValues.ERP,
        zones: (formValues.ERP.zones || []).map(zones => ({
          ...zones,
          zone: zones.zone || '1',
          delega: zones.delega || '030.01',
          store_name: zones.store_name || 'GUARDA 1500',
          article_constructor: zones.article_constructor || 'GUARDA1500',
        })),
        articles: (formValues.ERP.articles || []).map(article => ({
          ...article,
          name: article.name || '2PAX',
          article_constructor: article.article_constructor || '2PAX'
        })),
      }
    };
    return this.props.updateArticle(updatedFormValues).then(() => {
      this.props.fetchArticles();
    });
  }

  handleSaveSection(section) {
    this.props.handleSubmit(this.onSubmit)();
    switch (section) {
      case 'season':
        this.setState({ editSeason: false });
        break;
      case 'whitelist':
        this.setState({ editWhitelist: false });
        break;
      case 'clickandcollect':
        this.setState({ editClickAndCollect: false });
        break;
      case 'erp': // New case for ERP
        this.setState({ editERP: false });
        break;
      default:
        break;
    }
  }

  handleCancelEdit(section) {
    switch (section) {
      case 'season':
        this.setState({ editSeason: false });
        break;
      case 'whitelist':
        this.setState({ editWhitelist: false });
        break;
      case 'clickandcollect':
        this.setState({ editClickAndCollect: false });
        break;
      case 'erp': // New case for ERP
        this.setState({ editERP: false });
        break;
      default:
        break;
    }
  }

  getZoneName(zone) {

    switch (Number(zone)) {
      case 0:
        return 'GENERAL';
      case 1:
        return 'BAQUEIRA';
      case 2:
        return 'BERET';
      case 3:
        return 'BONAIGUA';
      case 4:
        return 'RUDA';
      case 5:
        return 'BOSQUE';
      case 6:
        return 'BOSQUE-CONSIGNAS';
      default:
        return 'NONE';
    }
  }

  getZoneColor(zone) {

    switch (Number(zone)) {
      case 0:
        return 'bg-primary';
      case 1:
        return 'bg-white';
      case 2:
        return 'bg-success';
      case 3:
        return 'bg-info';
      case 4:
        return 'bg-warning';
      case 5:
        return 'bg-secondary';
      case 6:
        return 'bg-secondary';
      default:
        return 'bg-danger';
    }
  }

  getTypeName(type) {

    switch (type) {
      case 'BN3XL':
        return '2 PAX';
      case 'CN3XL':
        return '3 PAX';
      case 'BW3XL':
        return '4 PAX';
      case 'CW3XL':
        return '3 PAX SS';
      case 'BNS':
        return 'Standard';
      case 'BNM':
        return 'Medium';
      default:
        return 'NONE';
    }
  }

  getLockerName(type) {

    switch (type) {
      case '2PAX':
        return '2 PAX';
      case '3PAX':
        return '3 PAX';
      case '4PAX':
        return '4 PAX';
      case '3PAXSS':
        return '3 PAX SS';
      case 'BNS':
        return 'Standard';
      case 'BNM':
        return 'Medium';
      default:
        return 'NONE';
    }
  }

  renderSeason(props) {
    const { fields } = props
    return (
      <div>
        {this.state.editSeason && (
          <div>
            <div className="av-edit-head cols-price">
              <span>Tipo</span>
              <span>Zona</span>
              <span>Precio</span>
              <span></span>
            </div>
            {fields.map((locker, index) => (
              <div className="av-edit-row cols-price" key={index}>
                <Field name={`${locker}.type`}
                  component={renderSelectField}
                >
                  <option value="BN3XL">2 PAX</option>
                  <option value="CN3XL">3 PAX</option>
                  <option value="BW3XL">4 PAX</option>
                  <option value="CW3XL">3 PAX SS</option>
                  <option value="BNS">Standard</option>
                  <option value="BNM">Medium</option>
                </Field>
                <Field
                  name={`${locker}.zone`}
                  component={renderSelectField}
                >
                  <option value="1">BAQUEIRA</option>
                  <option value="2">BERET</option>
                  <option value="3">BONAIGUA</option>
                  <option value="4">RUDA</option>
                  <option value="5">BOSQUE</option>
                  <option value="6">BOSQUE-CONSIGNAS</option>
                </Field>
                <Field
                  name={`${locker}.price`}
                  type="number"
                  component={renderInputField}
                />
                <button
                  className="av-remove-btn"
                  type="button"
                  onClick={() => fields.remove(index)}
                >
                  <i className="fas fa-trash"></i>
                </button>
              </div>
            ))}
            <div className="av-add-wrap">
              <button
                className="btn btn-vw av-add-btn"
                type="button"
                onClick={() => fields.push({})}
              >
                <i className="fas fa-plus mr-1"></i> Añadir
              </button>
            </div>
          </div>
        )}
      </div>
    )
  }

  renderOperators(props) {
    const { fields } = props
    return (
      <div>
        {this.state.editWhitelist && (
          <div>
            <div className="av-edit-head cols-white">
              <span>Nombre</span>
              <span>Color</span>
              <span>NIF/CIF</span>
              <span></span>
            </div>
            {fields.map((operator, index) => (
              <div className="av-edit-row cols-white" key={index}>
                <Field
                  name={`${operator}.name`}
                  type="text"
                  component={renderInputField}
                />
                <div className="av-color-cell">
                  <Field
                    name={`${operator}.color`}
                    component={ColorPickerField}
                  />
                </div>
                <Field
                  name={`${operator}.nif`}
                  type="text"
                  component={renderInputField}
                />
                <button
                  className="av-remove-btn"
                  type="button"
                  onClick={() => fields.remove(index)}
                >
                  <i className="fas fa-trash"></i>
                </button>
              </div>
            ))}
            <div className="av-add-wrap">
              <button
                className="btn btn-vw av-add-btn"
                type="button"
                onClick={() => fields.push({})}
              >
                <i className="fas fa-plus mr-1"></i> Añadir
              </button>
            </div>
          </div>
        )}
      </div>
    )
  }

  renderClick(props) {
    const { fields } = props
    return (
      <div>
        {this.state.editClickAndCollect && (
          <div>
            <div className="av-edit-head cols-price">
              <span>Tipo</span>
              <span>Zona</span>
              <span>Precio</span>
              <span></span>
            </div>
            {fields.map((locker, index) => (
              <div className="av-edit-row cols-price" key={index}>
                <Field name={`${locker}.type`}
                  component={renderSelectField}
                >
                  <option value="BN3XL">2 PAX</option>
                  <option value="CN3XL">3 PAX</option>
                  <option value="BW3XL">4 PAX</option>
                  <option value="CW3XL">3 PAX SS</option>
                  <option value="BNS">Standard</option>
                  <option value="BNM">Medium</option>
                </Field>
                <Field
                  name={`${locker}.zone`}
                  component={renderSelectField}
                >
                  <option value="1">BAQUEIRA</option>
                  <option value="2">BERET</option>
                  <option value="3">BONAIGUA</option>
                  <option value="4">RUDA</option>
                  <option value="5">BOSQUE</option>
                </Field>
                <Field
                  name={`${locker}.price`}
                  type="number"
                  component={renderInputField}
                />
                <button
                  className="av-remove-btn"
                  type="button"
                  onClick={() => fields.remove(index)}
                >
                  <i className="fas fa-trash"></i>
                </button>
              </div>
            ))}
            <div className="av-add-wrap">
              <button
                className="btn btn-vw av-add-btn"
                type="button"
                onClick={() => fields.push({})}
              >
                <i className="fas fa-plus mr-1"></i> Añadir
              </button>
            </div>
          </div>
        )}
      </div>
    )
  }

  renderSeasons(seasons) {
    return (
      <div className="table-responsive">
        <table className="table table-sm table-stripped">
          <thead className="thead-dark">
            <tr>
              <th scope="col">Zona</th>
              <th scope="col">Tipo</th>
              <th scope="col">Precio</th>
            </tr>
          </thead>
          <tbody>
            {seasons
              .slice() // Create a shallow copy of the array to avoid mutating the original array
              .sort((a, b) => {
                const nameA = this.getZoneName(a.zone).toUpperCase(); // Convert to uppercase to ensure case-insensitive comparison
                const nameB = this.getZoneName(b.zone).toUpperCase(); // Convert to uppercase to ensure case-insensitive comparison
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
              })
              .map((season, index) => (
                <tr key={index}>
                  <td scope="row"><span className={`av-zone-chip ${this.getZoneColor(season.zone)}`}>{this.getZoneName(season.zone)}</span></td>
                  <td scope="row">{this.getTypeName(season.type)}</td>
                  <td scope="row" className="av-price">{(season.price).toFixed(2)}€</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    )
  }

  renderClickandcollects(clickandcollects) {
    return (
      <div className="table-responsive">
        <table className="table table-sm table-stripped">
          <thead className="thead-dark">
            <tr>
              <th scope="col">Zona</th>
              <th scope="col">Tipo</th>
              <th scope="col">Precio</th>
            </tr>
          </thead>
          <tbody>
            {clickandcollects
              .slice() // Create a shallow copy of the array to avoid mutating the original array
              .sort((a, b) => {
                const nameA = this.getZoneName(a.zone).toUpperCase(); // Convert to uppercase to ensure case-insensitive comparison
                const nameB = this.getZoneName(b.zone).toUpperCase(); // Convert to uppercase to ensure case-insensitive comparison
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
              })
              .map((clickandcollect, index) => (
                <tr key={index}>
                  <td scope="row"><span className={`av-zone-chip ${this.getZoneColor(clickandcollect.zone)}`}>{this.getZoneName(clickandcollect.zone)}</span></td>
                  <td scope="row">{this.getTypeName(clickandcollect.type)}</td>
                  <td scope="row" className="av-price">{(clickandcollect.price).toFixed(2)}€</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    )
  }

  renderWhitelists(whitelists) {
    return (
      <div className="table-responsive">
        <table className="table table-sm table-stripped">
          <thead className="thead-dark">
            <tr>
              <th scope="col">Nombre</th>
              <th scope="col">Color</th>
              <th scope="col">NIF/CIF</th>
            </tr>
          </thead>
          <tbody>
            {whitelists.map((whitelist, index) => (
              <tr key={index}>
                <td scope="row">{whitelist.name}</td>
                <td scope="row">
                  <span
                    className="av-color-swatch"
                    style={{ backgroundColor: whitelist.color }}
                  ></span>
                </td>
                <td scope="row">{whitelist.nif}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }

  renderE(erp) {
    return (
      <div className="av-erp-grid">
        {/* Left column: fixed parameters */}
        <div>
          <div className="av-info-row">
            <span className="av-info-label">Company</span>
            <span className="av-info-value">{erp.company}</span>
          </div>
          <div className="av-info-row">
            <span className="av-info-label">Família Contable</span>
            <span className="av-info-value">{erp.accounting_code}</span>
          </div>
        </div>
        {/* Right column: lists */}
        <div className="av-erp-tables">
          <div>
            <h6 className="av-subheading"><i className="fas fa-map-marker-alt"></i>Zonas</h6>
            <div className="table-responsive">
              <table className="table table-sm table-stripped">
                <thead className="thead-dark">
                  <tr>
                    <th scope="col">Zona</th>
                    <th scope="col">Project</th>
                    <th scope="col">Delega</th>
                    <th scope="col">Store Name</th>
                    <th scope="col">Constructor</th>
                  </tr>
                </thead>
                <tbody>
                  {erp.zones.map((zone, index) => (
                    <tr key={index}>
                      <td scope="row"><span className={`av-zone-chip ${this.getZoneColor(zone.zone)}`}>{this.getZoneName(zone.zone)}</span></td>
                      <td scope="row">{zone.project}</td>
                      <td scope="row">{zone.delega}</td>
                      <td scope="row">{zone.store_name}</td>
                      <td scope="row">{zone.article_constructor}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div>
            <h6 className="av-subheading"><i className="fas fa-tags"></i>Artículos</h6>
            <div className="table-responsive">
              <table className="table table-sm table-stripped">
                <thead className="thead-dark">
                  <tr>
                    <th scope="col">Nombre</th>
                    <th scope="col">Constructor</th>
                  </tr>
                </thead>
                <tbody>
                  {erp.articles.map((article, index) => (
                    <tr key={index}>
                      <td scope="row">{this.getLockerName(article.name)}</td>
                      <td scope="row">{article.article_constructor}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderERP() {
    return (
      <div>
        {this.state.editERP && (
          <div className="av-erp-grid">
            <div>
              <Field
                name="ERP.company"
                type="text"
                component={renderInputField}
                label="Company"
              />
              <Field
                name="ERP.accounting_code"
                type="text"
                component={renderInputField}
                label="Família Contable"
              />
            </div>
            <div className="av-erp-tables">
              <div>
                <h6 className="av-subheading"><i className="fas fa-map-marker-alt"></i>Zonas</h6>
                <FieldArray name="ERP.zones" component={this.renderERPZones} />
              </div>
              <div>
                <h6 className="av-subheading"><i className="fas fa-tags"></i>Artículos</h6>
                <FieldArray name="ERP.articles" component={this.renderERPArticles} />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  renderERPZones({ fields }) {
    return (
      <div>
        <div className="av-edit-head cols-erpzone">
          <span>Zona</span>
          <span>Project</span>
          <span>Delega</span>
          <span>Store Name</span>
          <span>Constructor</span>
          <span></span>
        </div>
        {fields.map((zone, index) => (
          <div className="av-edit-row cols-erpzone" key={index}>
            <Field
              name={`${zone}.zone`}
              component={renderSelectField}
            >
              <option value="1">BAQUEIRA</option>
              <option value="2">BERET</option>
              <option value="3">BONAIGUA</option>
              <option value="4">RUDA</option>
              <option value="5">BOSQUE</option>
              <option value="6">BOSQUE-CONSIGNAS</option>
            </Field>
            <Field
              name={`${zone}.project`}
              type="text"
              component={renderInputField}
            />
            <Field
              name={`${zone}.delega`}
              type="text"
              component={renderInputField}
            />
            <Field
              name={`${zone}.store_name`}
              type="text"
              component={renderInputField}
            />
            <Field
              name={`${zone}.article_constructor`}
              type="text"
              component={renderInputField}
            />
            <button
              className="av-remove-btn"
              type="button"
              onClick={() => fields.remove(index)}
            >
              <i className="fas fa-trash"></i>
            </button>
          </div>
        ))}
        <div className="av-add-wrap">
          <button
            className="btn btn-vw av-add-btn"
            type="button"
            onClick={() => fields.push({})}
          >
            <i className="fas fa-plus mr-1"></i> Añadir
          </button>
        </div>
      </div>
    );
  }

  renderERPArticles({ fields }) {
    return (
      <div>
        <div className="av-edit-head cols-erpart">
          <span>Nombre</span>
          <span>Constructor</span>
          <span></span>
        </div>
        {fields.map((article, index) => (
          <div className="av-edit-row cols-erpart" key={index}>
            <Field
              name={`${article}.name`}
              component={renderSelectField}
            >
              <option value="2PAX">2 PAX</option>
              <option value="3PAX">3 PAX</option>
              <option value="4PAX">4 PAX</option>
              <option value="3PAXSS">3 PAX SS</option>
              <option value="BNS">Standard</option>
              <option value="BNM">Medium</option>
            </Field>
            <Field
              name={`${article}.article_constructor`}
              type="text"
              component={renderInputField}
            />
            <button
              className="av-remove-btn"
              type="button"
              onClick={() => fields.remove(index)}
            >
              <i className="fas fa-trash"></i>
            </button>
          </div>
        ))}
        <div className="av-add-wrap">
          <button
            className="btn btn-vw av-add-btn"
            type="button"
            onClick={() => fields.push({})}
          >
            <i className="fas fa-plus mr-1"></i> Añadir
          </button>
        </div>
      </div>
    );
  }

  renderSectionCard(title, icon, section, isEditing, readContent, editContent) {
    return (
      <div className={`articles-card${section === 'erp' ? ' full-width' : ''}`}>
        <div className="articles-card-header">
          <span className="av-card-title">
            <i className={`fas ${icon}`}></i>
            {title}
          </span>
          {!isEditing && (
            <button
              className="av-edit-btn"
              type="button"
              onClick={() => this.setState({
                editSeason: section === 'season' ? true : this.state.editSeason,
                editWhitelist: section === 'whitelist' ? true : this.state.editWhitelist,
                editClickAndCollect: section === 'clickandcollect' ? true : this.state.editClickAndCollect,
                editERP: section === 'erp' ? true : this.state.editERP,
              })}
            >
              <i className="fas fa-edit"></i>
              Editar
            </button>
          )}
        </div>
        <div className="articles-card-body">
          {!isEditing && readContent}
          {isEditing && (
            <>
              {editContent}
              <div className="av-section-footer">
                <button
                  className="btn av-btn-cancel"
                  type="button"
                  onClick={() => this.handleCancelEdit(section)}
                >
                  <i className="fas fa-times mr-1"></i>
                  Cancelar
                </button>
                <button
                  className="btn av-btn-save"
                  type="button"
                  onClick={() => this.handleSaveSection(section)}
                >
                  <i className="fas fa-save mr-1"></i>
                  Guardar
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    )
  }

  render() {
    const { handleSubmit, loading, error, articles } = this.props

    if (loading || !articles) {
      return <LoadingProgress />;
    }

    return (
      <div className="articles-view">
        {/* Header Section */}
        <div className="articles-header">
          <h1 className="articles-title">
            <i className="fas fa-tags"></i>
            ARTÍCULOS
          </h1>
        </div>

        {error && <div className="alert alert-danger">{error}</div>}

        <form className="opform" onSubmit={handleSubmit(this.onSubmit)}>
          <div className="articles-grid">
            {this.renderSectionCard(
              'Precios de Temporada',
              'fa-snowflake',
              'season',
              this.state.editSeason,
              this.renderSeasons(articles.Season),
              <FieldArray name="Season" component={this.renderSeason} />
            )}

            {this.renderSectionCard(
              'Listas blancas',
              'fa-user-check',
              'whitelist',
              this.state.editWhitelist,
              this.renderWhitelists(articles.Whitelist),
              <FieldArray name="Whitelist" component={this.renderOperators} />
            )}

            {this.renderSectionCard(
              'Precios Click&Collect',
              'fa-box-open',
              'clickandcollect',
              this.state.editClickAndCollect,
              this.renderClickandcollects(articles.ClickAndCollect),
              <FieldArray name="ClickAndCollect" component={this.renderClick} />
            )}

            {this.renderSectionCard(
              'Datos ERP',
              'fa-file-invoice',
              'erp',
              this.state.editERP,
              this.renderE(articles.ERP),
              this.renderERP()
            )}
          </div>
        </form>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  articles: state.articles.articles,
  loading: state.articles.loading,
  error: state.articles.error,
  initialValues: {
    ...state.articles.articles
  }
})

const mapDispatchToProps = (dispatch) => ({
  fetchArticles: bindActionCreators(fetchArticles, dispatch),
  updateArticle: bindActionCreators(updateArticle, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'ArticlesForm',
    enableReinitialize: true
  })(ArticlesView)
)
